import { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  TextInput,
  Button,
  Paper,
  Title,
  Container,
  Stack,
  Alert,
  Text,
  Anchor,
} from '@mantine/core';
import { IconAlertCircle, IconCheck } from '@tabler/icons-react';
import { authApi } from '@/services/auth.api';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [tenantSlug, setTenantSlug] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await authApi.requestPasswordReset(email, tenantSlug);
      setSuccess(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Request failed');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <Container size={420} my={40}>
        <Title ta="center" mb="xl">
          Check Your Email
        </Title>

        <Paper withBorder shadow="md" p={30} radius="md">
          <Alert icon={<IconCheck size={16} />} title="Request Sent" color="green" mb="md">
            If your email exists in our system, you will receive a password reset link shortly.
          </Alert>

          <Text size="sm" c="dimmed" mb="md">
            Check your spam folder if you don't see the email within a few minutes.
          </Text>

          <Button variant="light" fullWidth component={Link} to="/login">
            Back to Login
          </Button>
        </Paper>
      </Container>
    );
  }

  return (
    <Container size={420} my={40}>
      <Title ta="center" mb="xl">
        Forgot Password
      </Title>

      <Paper withBorder shadow="md" p={30} radius="md">
        <form onSubmit={handleSubmit}>
          <Stack>
            {error && (
              <Alert icon={<IconAlertCircle size={16} />} title="Error" color="red">
                {error}
              </Alert>
            )}

            <Text size="sm" c="dimmed">
              Enter your email and tenant to receive a password reset link.
            </Text>

            <TextInput
              label="Tenant"
              placeholder="demo"
              required
              value={tenantSlug}
              onChange={(e) => setTenantSlug(e.currentTarget.value)}
            />

            <TextInput
              label="Email"
              placeholder="your@email.com"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.currentTarget.value)}
            />

            <Button type="submit" fullWidth loading={loading}>
              Send Reset Link
            </Button>

            <Text size="sm" ta="center">
              Remember your password?{' '}
              <Anchor component={Link} to="/login">
                Sign in
              </Anchor>
            </Text>
          </Stack>
        </form>
      </Paper>
    </Container>
  );
}
